import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import type { IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageGameStatus } from './voyageGameStatus-sidecar'

export interface IVoyageCrewAlien {
  // fireExtinguishTimer: number
  // useSystemTimer: number
}

export function create() {
  let d: IVoyageCrewAlien = {
    // fireExtinguishTimer: 0,
    // useSystemTimer: 0,
  }
  return d
}

export function update(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.alienState
  assert.notNil(d)

  if (obj.isDead) {
    return
  }

  voyageGameStatus.get().hasBoarders.willBeActive = true

  if (obj.hitpoints <= 0) {
    voyageCrew.kill(obj)
    return
  }
}
